<template>
  <div class="navbarComponent">
    <div class="container-sm">
      <div class="inside">
        <div class="case-status">
          <el-row type="flex" :align="middle" justify="end" style="width: 100%">
            <el-col
              :sm="4"
              v-if="hasPermission('cases', 'edit_new') && !isBillingUser"
            >
              <div class="editCase">
                <button class="editButton btn" @click="goToEditForm">
                  <span class="pr-5"> EDIT </span>
                </button>
              </div>
            </el-col>
            <el-col
              :sm="4"
              v-if="
                !isCaseCompleted &&
                hasPermission('cases', 'edit_new') &&
                isBillingUser
              "
            >
              <div class="editCase">
                <button class="editButton btn" @click="goToEditForm">
                  <span class="pr-5"> EDIT </span>
                </button>
              </div>
            </el-col>
            <el-col
              :sm="4"
              v-if="
                isReleasePending &&
                this.getCaseInformation &&
                this.getCaseInformation.release == false
              "
            >
              <div class="editCase">
                <button class="editButton btn" @click="goToEditForm">
                  <span class="pr-5"> RESOLVE </span>
                </button>
              </div>
            </el-col>
            <el-col :sm="20">
              <ul class="justify-content-end">
                <li>
                  <div v-if="caseInfo && caseInfo.is_amendement">
                    <el-alert
                      title="Case Details Amended"
                      type="primary"
                      :description="description"
                      :closable="false"
                    />
                  </div>
                </li>
                <li>
                  <h3 class="name">Case Status</h3>
                </li>
                <li v-if="caseInfo && caseInfo.status">
                  <el-dropdown
                    class="column-status"
                    @command="(command) => changeStatus(command, caseId)"
                    trigger="click"
                    v-if="
                      hasPermission('cases', 'update_status') &&
                      caseInfo.status != 'ARCHIVED'
                    "
                  >
                    <el-tag
                      :type="getStatusType(caseInfo.status)"
                      style="cursor: pointer"
                    >
                      <span class="pr-5" v-if="caseInfo.status === 'COMPLETE'"
                        >FINALIZED</span
                      >
                      <span
                        class="pr-5"
                        v-else-if="caseInfo.status === 'TEST_REPORTS'"
                        >PROCESSING</span
                      >
                      <span class="pr-5" v-else>{{
                        this.caseInfo.status.split("_").join(" ")
                      }}</span>
                    </el-tag>
                    <template
                      #dropdown
                      v-if="
                        caseInfo.status &&
                        (caseInfo.status == 'REJECTED' ||
                          caseInfo.status == 'PENDING')
                      "
                    >
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item
                          command="ACTIVE"
                          :disabled="caseInfo.status === 'ACTIVE'"
                          >ACTIVE</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="PENDING"
                          :disabled="caseInfo.status === 'PENDING'"
                        >
                          PENDING
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="REJECTED"
                          :disabled="caseInfo.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                    <template
                      #dropdown
                      v-else-if="
                        caseInfo.status &&
                        (caseInfo.status == 'COMPLETE' ||
                          caseInfo.status == 'TEST_REPORTS')
                      "
                    >
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item
                          command="TEST_REPORTS"
                          :disabled="caseInfo.status === 'TEST_REPORTS'"
                          >PROCESSING</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="COMPLETE"
                          :disabled="caseInfo.status === 'COMPLETE'"
                          >FINALIZED</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                    <template
                      #dropdown
                      v-else-if="
                        caseInfo.status &&
                        (caseInfo.status == 'ACTIVE' ||
                          caseInfo.status == 'INITIATE')
                      "
                    >
                      <el-dropdown-menu
                        class="status-dropdown-menu center-dropdown"
                      >
                        <el-dropdown-item
                          command="PENDING"
                          :disabled="caseInfo.status === 'PENDING'"
                        >
                          PENDING
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="REJECTED"
                          v-if="
                            !this.getCaseInformation.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            )
                          "
                          :disabled="caseInfo.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="REJECTED"
                          v-if="
                            this.getCaseInformation.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            ) && !hasMoreThanOneUniqueCategoryCode()
                          "
                          :disabled="caseInfo.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>
                        <el-dropdown-item
                          command="NOT_TO_CALL"
                          v-if="
                            this.getCaseInformation.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            ) && hasMoreThanOneUniqueCategoryCode()
                          "
                          :disabled="caseInfo.status === 'REJECTED'"
                        >
                          <span
                            class="view-button"
                            title="Reject"
                            @click="rejectTests()"
                          >
                            REJECTED
                          </span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                  <div class="column-status" v-else>
                    <el-tag :type="getStatusType(caseInfo.status)">
                      {{
                        (!isBillingUser || isLabAssistantUser || isLabAdmin) &&
                        caseInfo.status === "ACTIVE"
                          ? "ACTIVE"
                          : (!isBillingUser ||
                              isLabAssistantUser ||
                              isLabAdmin) &&
                            caseInfo.status === "TEST_REPORTS"
                          ? "PROCESSING"
                          : caseInfo.status === "COMPLETE" &&
                            caseInfo.release == false
                          ? "ACTIVE"
                          : caseInfo.priliminary_report_generated === true &&
                            caseInfo.status == "ACTIVE"
                          ? "PRELIMINARY"
                          : caseInfo.status === "COMPLETE"
                          ? "FINALIZED"
                          : caseInfo.status === "ARCHIVED"
                          ? "ARCHIVED"
                          : caseInfo.status === "PENDING"
                          ? "PENDING"
                          : caseInfo.status === "REJECTED"
                          ? "REJECTED"
                          : caseInfo.status === "TEST_REPORTS"
                          ? "ACTIVE"
                          : "PROCESSING"
                      }}
                    </el-tag>
                  </div>
                </li>

                <li v-if="hasPermission('generate_barcode', 'view')">
                  <el-button
                    class="pr-5"
                    id="generate-barcode-button"
                    @click="viewQrcode"
                  >
                    PRINT QRCODE
                  </el-button>
                </li>
                <li v-if="hasPermission('generate_barcode', 'view')">
                  <el-button
                    class="pr-5"
                    id="generate-barcode-button"
                    @click="viewBarcode"
                  >
                    PRINT BARCODE
                  </el-button>
                </li>
                <li v-if="hasPermission('cases', 'create')">
                  <el-button class="pr-5" @click="viewCaseAudit">
                    Audit
                  </el-button>
                </li>
                <li v-if="hasPermission('cases', 'insurance_history')">
                  <el-button class="pr-5" @click="getPatietHistory">
                    Patient History
                  </el-button>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
  <section
    v-loading="loading"
    class="new-case-view case-creation"
    id="single-case-view"
  >
    <div
      class="order-status-reason"
      v-if="this.caseInfo && this.caseInfo.reasons && this.caseInfo.notes"
    >
      <div class="container-sm">
        <div class="bg-white">
          <ul>
            <li>
              <h4 class="reason-heading">Reasons :</h4>
            </li>
            <li v-for="(reason, index) in this.caseInfo.reasons" :key="index">
              <p>{{ reason }}</p>
            </li>
          </ul>
          <ul>
            <li>
              <h4 class="reason-heading">Notes :</h4>
            </li>
            <li>
              <p>{{ caseInfo.notes }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="case-view-body">
      <div class="container-sm">
        <section id="view-case-screen">
          <PatientInformation></PatientInformation>
          <span class="case-creation__divider"></span>
          <CaseInformation></CaseInformation>
          <span class="case-creation__divider"></span>
          <div
            v-if="
              !isBillingUser &&
              isCaseCompleted &&
              this.getCaseInformation &&
              this.getCaseInformation.is_sendout
            "
          >
            <SendoutLab></SendoutLab>
          </div>
          <div v-if="!isBillingUser && isCaseCompleted">
            <CPTCodes></CPTCodes>
          </div>
          <div v-if="!isBillingUser && isCaseCompleted">
            <BillingNotes></BillingNotes>
          </div>
          <div v-if="hasPermission('billing', 'view') && isCaseCompleted">
            <BillingCategory></BillingCategory>
          </div>
          <span class="case-creation__divider" v-if="!isBillingUser"></span>
          <div
            v-if="
              this.getCaseInformation &&
              this.getCaseInformation.case_types &&
              this.getCaseInformation.case_types.includes('TOXICOLOGY')
            "
          >
            <ToxicologyOrderChecklistView></ToxicologyOrderChecklistView>
          </div>
          <span class="case-creation__divider"></span>
          <TestInformation></TestInformation>
          <span class="case-creation__divider"></span>

          <div v-if="isCaseHavingAdditionalNotes">
            <AdditionalNotes></AdditionalNotes>
          </div>
          <span class="case-creation__divider"></span>
          <Medication></Medication>
          <div
            v-if="
              hasBloodPanel &&
              hasPermission('result_files', 'add') &&
              isBillingUser
            "
          >
            <TestResults></TestResults>
          </div>
          <div
            v-if="hasClinicalChemistryCase && show && isBillingUser && checkLab"
          >
            <TestResults></TestResults>
          </div>
          <span class="case-creation__divider" v-if="hasBillingType"></span>
          <div v-if="hasBillingType">
            <BillingInformation></BillingInformation>
          </div>
          <span class="case-creation__divider"></span>
          <div class="attachment-test-performed-block">
            <div
              class="requisition-d-grid"
              v-if="
                hasPermission('test_performed_by', 'view') &&
                isBillingUser &&
                !hasClinicalChemistry
              "
            >
              <div class="leftBlock">
                <div>
                  <ErequisitionForm></ErequisitionForm>
                </div>
                <div v-if="show" class="mt-10">
                  <TestAttachments></TestAttachments>
                </div>
              </div>
              <div>
                <TestPerformedBy></TestPerformedBy>
              </div>
            </div>
            <div v-else>
              <div class="requisition-d-grid">
                <div v-if="show">
                  <TestAttachments></TestAttachments>
                </div>
                <div v-if="!this.getAuthenticatedUser.allow_unathorized_access">
                  <ErequisitionForm></ErequisitionForm>
                </div>
              </div>
            </div>
          </div>
          <span class="case-creation__divider"></span>

          <TestReport :displayUploading="true"></TestReport>
          <span class="case-creation__divider"></span>
          <ReasonForStatusChange
            v-if="takeStatusChangeReasonDialog"
            v-on:close="takeStatusChangeReasonDialog = false"
            v-on:reasonSubmit="unsetCaseCompleteStatus"
            :width="40"
            :title="takeStatusChangeReasonDialogTitle"
          >
          </ReasonForStatusChange>
        </section>
      </div>
    </div>
    <TestsRejectPopup
      :showRejectTestPopup="showRejectTestPopup"
      :groupedTests="groupedTests"
      :selectedTests="selectedTests"
      :selectedPanels="selectedPanels"
      :formData="formData"
      :loading="loading"
      :rejectCaseError="rejectCaseError"
      :isRejectButtonDisabled="isRejectButtonDisabled"
      :predefinedReasons="predefinedReasons"
      @close-popup="closeIconRejectPopup"
      @update-individual-test="updateIndividualTest"
      @select-panel-tests="selectPanelTests"
      @update-reasons="(val) => (formData.selectedReasons = val)"
      @update-notes="updateNotes"
      @form-validated="rejectSelectedTests"
    />

    <AuditLogs
      v-if="AuditLogsPopup"
      v-on:close="AuditLogsPopup = false"
      :caseId="caseId"
    ></AuditLogs>
    <PatientBillingHistory
      v-if="patientHistory"
      v-on:close="patientHistory = false"
      :patientId="patientId"
    >
    </PatientBillingHistory>
    <ReasonForStatusMoving
      v-if="takeStatusMovingReasonDialog"
      v-on:close="takeStatusMovingReasonDialog = false"
      v-on:reasonSubmit="unsetCaseMovingStatus"
      :width="40"
      :title="takeStatusChangeReasonDialogTitle"
    >
    </ReasonForStatusMoving>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
const TestInformation = defineAsyncComponent(() =>
  import("@/components/cases/ViewTests")
);
const BillingNotes = defineAsyncComponent(() =>
  import("@/components/cases/BillingNotes")
);
const BillingCategory = defineAsyncComponent(() =>
  import("@/components/cases/BillingCategory")
);
const CPTCodes = defineAsyncComponent(() =>
  import("@/components/cases/CPTCodes")
);
const PatientInformation = defineAsyncComponent(() =>
  import("@/components/cases/PatientInformation")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/cases/CaseInformation")
);
const TestPerformedBy = defineAsyncComponent(() =>
  import("@/components/cases/TestPerformedBy")
);
const Medication = defineAsyncComponent(() =>
  import("@/components/cases/MedicationView")
);
const BillingInformation = defineAsyncComponent(() =>
  import("@/components/cases/BillingInformation")
);
const TestAttachments = defineAsyncComponent(() =>
  import("@/components/cases/TestAttachments")
);
const ErequisitionForm = defineAsyncComponent(() =>
  import("@/components/cases/Erequisition")
);
const TestResults = defineAsyncComponent(() =>
  import("@/components/cases/TestResults")
);
const TestReport = defineAsyncComponent(() =>
  import("@/components/cases/ViewTestReport")
);
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
const ReasonForStatusChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import AuditLogs from "@/components/cases/AllLogs";
const AdditionalNotes = defineAsyncComponent(() =>
  import("@/components/cases/AdditionalNotes")
);
const ToxicologyOrderChecklistView = defineAsyncComponent(() =>
  import("@/components/cases/ToxicologyOrderChecklistView")
);
import PatientBillingHistory from "@/components/cases/PatientBillingHistory";
const SendoutLab = defineAsyncComponent(() =>
  import("@/components/cases/ReferenceLab")
);
const ReasonForStatusMoving = defineAsyncComponent(() =>
  import("@/components/misc/OrderReasonForChange")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import TestsRejectPopup from "../../components/cases/TestsRejectPopup.vue";

export default {
  components: {
    TestInformation,
    PatientInformation,
    CaseInformation,
    Medication,
    BillingInformation,
    TestAttachments,
    ErequisitionForm,
    TestResults,
    TestReport,
    ReasonForStatusChange,
    TestPerformedBy,
    BillingNotes,
    CPTCodes,
    BillingCategory,
    AuditLogs,
    AdditionalNotes,
    ToxicologyOrderChecklistView,
    PatientBillingHistory,
    SendoutLab,
    ReasonForStatusMoving,
    TestsRejectPopup,
  },
  mixins: [UserPermissionsHelper, AppHelper],
  data() {
    return {
      scrollPosition: null,
      description: "",
      loading: false,
      show: false,
      unsetCompleteStatusChangeCase: "",
      takeStatusChangeReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
      toStatus: "",
      refreshView: false,
      caseId: "",
      AuditLogsPopup: false,
      showTests: false,
      orderId: "",
      patientHistory: false,
      takeStatusMovingReasonDialog: false,
      showRejectTestPopup: false,
      groupedTests: {},
      selectedTests: {},
      selectedPanels: {},
      formData: {
        selectedReasons: [],
        notes: "",
      },
      rejectCaseError: "",
      predefinedReasons: [
        {
          value: "Insufficient sample received",
          label: "Insufficient sample received",
        },
        {
          value: "Incorrect specimen received",
          label: "Incorrect specimen received",
        },
        { value: "Turnaround time", label: "Turnaround time" },

        {
          value: "Specimen received without requisition",
          label: "Specimen received without requisition",
        },
        { value: "Early collection", label: "Early collection" },
        {
          value: "Only requisition received without sample",
          label: "Only requisition received without sample",
        },
        {
          value: "Sample has leaked in transit",
          label: "Sample has leaked in transit",
        },
        {
          value: "Hemolyzed or clotted specimen",
          label: "Hemolyzed or clotted specimen",
        },
        { value: "Invalid insurance", label: "Invalid insurance" },
        {
          value: "Inactive insurance",
          label: "Inactive insurance",
        },
        {
          value: "Invalid ICD codes",
          label: "Invalid ICD codes",
        },
        {
          label: "The date of collection is missing in the requisition",
          value: "The date of collection is missing in the requisition",
        },
        {
          label: "ICD codes are missing in the requisition",
          value: "ICD codes are missing in the requisition.",
        },
        {
          value: "The test is not marked correctly",
          label: "The test is not marked correctly",
        },
        {
          value: "Specimen and test mismatch",
          label: "Specimen and test mismatch",
        },
        {
          value: "Medications are needed",
          label: "Medications are needed",
        },
        {
          value: "Insurance details are missing",
          label: "Insurance details are missing",
        },
        {
          value: "There is a billing mismatch",
          label: "There is a billing mismatch",
        },
        // Add more predefined reasons as needed
      ],
      reasonToActionMap: {
        "Insufficient sample received":
          "Please provide a specimen with sufficient quantity for processing the test.",
        "Incorrect specimen received":
          "Please provide the correct specimen type related to the test ordered.",
        "Turnaround time":
          "Please minimize the time delay between specimen collection and specimen receipt.",
        "Specimen received without requisition":
          "Please provide the requisition form to process the testing.",
        "Only requisition received without sample":
          "Please provide the sample for test processing along with the updated requisition.",
        "Sample has leaked in transit":
          "Please provide a fresh sample to process the test.",
        "Hemolyzed or clotted specimen":
          "Please recollect the sample as it needs to be in proper condition for testing.",
        "Invalid insurance":
          "Please provide valid insurance details along with a copy of the insurance.",
        "Inactive insurance":
          "Please provide active insurance details along with a copy of the insurance.",
        "Invalid ICD codes":
          "Please provide valid ICD codes to process the test.",
        "The date of collection is missing in the requisition":
          "We need the date of collection to process the test.",
        "ICD codes are missing in the requisition":
          "Please provide the ICD code for test processing.",
        "The test is not marked correctly":
          "We need an updated requisition to process the testing.",
        "Specimen and test mismatch":
          "The specimen and requisition are incompatible.",
        "Medications are needed":
          "We require the medications for test processing.",
        "Insurance details are missing":
          "Please provide the insurance details and a copy of the insurance card.",
        "There is a billing mismatch":
          "The bill-to information is marked incorrectly.",
      },
    };
  },
  computed: {
    ...mapGetters("cases", [
      "getCaseInformation",
      "getShowMedication",
      "getUpdateCaseStatus",
      "getPreviewCaseData",
    ]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserAllowedLabs",
      "getUserPrimaryLabId",
    ]),
    ...mapGetters("logs", ["getAllLogs"]),
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    caseInfo() {
      return this.getCaseInformation
        ? JSON.parse(JSON.stringify(this.getCaseInformation))
        : null;
    },
    hasClinicalChemistry() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    hasBloodPanel() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          (this.getCaseInformation.case_types.indexOf("URINALYSIS") > -1 ||
            this.getCaseInformation.case_types.indexOf("TOXICOLOGY") > -1)
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    hasClinicalChemistryCase() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    isCaseCompleted() {
      if (!this.getCaseInformation) {
        return false;
      }
      return this.getCaseInformation.status === "COMPLETE";
    },
    hasBillingType() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.billing_type &&
        (this.getCaseInformation.billing_type == "INSURANCE" ||
          this.getCaseInformation.billing_type == "PATIENT" ||
          this.getCaseInformation.billing_type == "CLIENT" ||
          this.getCaseInformation.billing_type == "LABCORP")
      ) {
        return true;
      }
      return false;
    },
    isCaseHavingAdditionalNotes() {
      if (this.getCaseInformation && this.getCaseInformation.physician_notes) {
        return true;
      }
      return false;
    },
    isOrder() {
      if (this.getCaseInformation && this.getCaseInformation.order_id) {
        return true;
      }
      return false;
    },
    patientId() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.patient_info &&
        this.getCaseInformation.patient_info._id
      ) {
        return this.getCaseInformation.patient_info._id;
      }
      return null;
    },
    checkLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && matchedLab.lab_code == "DLW-TX") {
          return true;
        }
        return false;
      }
      return false;
    },
    isRejectButtonDisabled() {
      const hasSelectedTests = Object.keys(this.selectedTests).length > 0;
      const hasSelectedPanels = Object.values(this.selectedPanels).some(
        Boolean
      );
      const hasReasons =
        Array.isArray(this.formData.selectedReasons) &&
        this.formData.selectedReasons.length > 0;
      const hasValidNotes =
        typeof this.formData.notes === "string" &&
        this.formData.notes.trim().length >= 3;

      // Enable button only if: (tests OR panels selected) AND reasons AND valid notes
      return (
        this.allItemsSelected ||
        !(
          (hasSelectedTests || hasSelectedPanels) &&
          hasReasons &&
          hasValidNotes
        )
      );
    },
    totalRejectableItems() {
      // Calculate total rejectable items:
      // - Panels (excluding ALL_TESTS and SEND_OUTS if they exist)
      // - Individual tests in ALL_TESTS and SEND_OUTS if they exist
      const excludedPanels = ["ALL_TESTS", "SEND_OUTS"].filter((panel) =>
        Object.keys(this.groupedTests).includes(panel)
      ).length;

      console.log(excludedPanels, "excludedPanels");
      const panelCount = Object.keys(this.groupedTests).length - excludedPanels;
      const testCount =
        (this.groupedTests["ALL_TESTS"]?.tests?.length || 0) +
        (this.groupedTests["SEND_OUTS"]?.tests?.length || 0);
      console.log(panelCount + testCount);
      return panelCount + testCount;
    },
    selectedLength() {
      const testsLength = Object.keys(this.selectedTests).length;
      const panelsLength = Object.keys(this.selectedPanels).length;
      console.log(testsLength, ":testsLength", panelsLength, ": panelsLength");
      console.log(testsLength + panelsLength, "selectedLength");
      return testsLength + panelsLength;
    },
    allItemsSelected() {
      // Check if all rejectable items are selected
      if (this.selectedLength === this.totalRejectableItems) {
        return true;
      } else {
        return false;
      }
    },
  },
  async mounted() {
    this.caseId = this.$route.params.case_id;
    await this.fetchCaseInformation();
    this.show = true;
    this.showTests = true;
    // Add Class to body on scroll
    window.addEventListener("scroll", this.onScroll);
  },
  async unmounted() {
    // Remove Class to body on scroll
    document.body.classList.remove("fixedNavbarOnComponent");
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    updateNotes() {
      const actions = this.formData.selectedReasons
        .map((reason) => this.reasonToActionMap[reason])
        .filter((action) => action);
      this.formData.notes = actions.join("\n");
    },
    async rejectSelectedTests() {
      this.rejectCaseError = "";
      this.loading = true;
      try {
        const panels = [];
        const selectedPanelCodes = Object.keys(this.selectedPanels).filter(
          (code) => this.selectedPanels[code]
        );
        const includedPanelIds = new Set();
        // ✅ Step 1: Add full panels
        for (const panelCode of selectedPanelCodes) {
          const panelData = this.groupedTests[panelCode];
          if (!panelData) continue;

          panels.push({
            panel_id: panelData.panel_id,
            case_type_code: panelData.case_type_code || "CLINICAL_CHEMISTRY",
            all_tests: true,
            test_ids: panelData.tests.map((test) => test._id),
            lab_order_code: panelData.lab_order_code || "",
          });

          includedPanelIds.add(panelData.panel_id);
        }

        // ✅ Step 2: Handle individually selected tests
        const groupedByPanel = {};

        for (const [testId, testInfo] of Object.entries(this.selectedTests)) {
          if (includedPanelIds.has(testInfo.panel_id)) continue; // Skip already handled

          if (
            testInfo.panel_code === "ALL_TESTS" ||
            testInfo.panel_code === "SEND_OUTS"
          ) {
            // ✅ Split ALL_TESTS entries into separate panel objects
            panels.push({
              panel_id: testInfo.panel_id,
              case_type_code: testInfo.case_type_code || "CLINICAL_CHEMISTRY",
              all_tests: true,
              test_ids: [testId],
              lab_order_code: testInfo.lab_order_code || "",
            });
          } else {
            // Group by panel_id normally
            if (!groupedByPanel[testInfo.panel_id]) {
              groupedByPanel[testInfo.panel_id] = {
                panel_id: testInfo.panel_id,
                case_type_code: testInfo.case_type_code || "CLINICAL_CHEMISTRY",
                all_tests: true,
                test_ids: [],
                lab_order_code: testInfo.lab_order_code || "",
              };
            }
            groupedByPanel[testInfo.panel_id].test_ids.push(testId);
          }
        }

        // ✅ Merge grouped panels (non-"ALL_TESTS") into final panels array
        panels.push(...Object.values(groupedByPanel));

        // ✅ Create tests_info
        const tests_info = panels.flatMap((panel) => panel.test_ids);

        // ✅ Final payload
        const params = {
          case_id: this.caseId,
          panels,
          tests_info,
          notes: this.formData.notes,
          reasons: this.formData.selectedReasons,
        };
        await this.$store.dispatch("rejectTestInfo/createCCRCase", params);
        if (panels.length > 0) {
          successNotification("Test rejected successfully");
        }
        this.closeIconRejectPopup();
        this.caseId = this.$route.params.case_id;
        await this.fetchCaseInformation();
        window.location.reload();
        this.show = true;
        this.showTests = true;
        // Add Class to body on scroll
        window.addEventListener("scroll", this.onScroll);
      } catch (error) {
        console.error("Error rejecting tests:", error);
        this.rejectCaseError = "Error Rejecting Tests";
      } finally {
        this.loading = false;
      }
    },
    updateIndividualTest(
      testId,
      isChecked,
      panelId,
      caseTypeCode,
      testName,
      testCode,
      labOrderCode,
      panelCode
    ) {
      if (isChecked) {
        this.selectedTests = {
          ...this.selectedTests,
          [testId]: {
            panel_id: panelId,
            case_type_code: caseTypeCode,
            test_name: testName,
            test_code: testCode,
            lab_order_code: labOrderCode,
            panel_code: panelCode, // ✅ added here
          },
        };
      } else {
        const updated = { ...this.selectedTests };
        delete updated[testId];
        this.selectedTests = updated;
      }
      this.checkAllItemsSelected();
    },

    selectPanelTests(panelCode, isChecked) {
      const panel = this.groupedTests[panelCode];

      if (panel) {
        if (isChecked) {
          // ✅ Select panel
          this.selectedPanels[panelCode] = true;
        } else {
          // ❌ Remove deselected panel from selectedPanels
          delete this.selectedPanels[panelCode];

          // ❌ Clear all related tests from selectedTests
          // if (panel.tests) {
          //   panel.tests.forEach(test => {
          //     delete this.selectedTests[test._id];
          //   });
          // }
        }
      } else {
        console.warn(`Panel ${panelCode} not found`);
      }
      this.checkAllItemsSelected();
    },
    closeIconRejectPopup() {
      this.rejectCaseError = "";
      this.showRejectTestPopup = false;
      this.groupedTests = {};

      this.selectedPanels = {};
      this.selectedTests = {};

      // Clear formData
      this.formData.selectedReasons = [];
      this.formData.notes = "";

      this.$nextTick(() => {
        this.$refs.ruleForm?.resetFields();
      });
    },

    async rejectTests() {
      if (!this.getCaseInformation?.test_panel_info) {
        this.groupedTests = {};
        this.showRejectTestPopup = true;
        return;
      }

      const grouped = {};

      const panels = this.getCaseInformation.test_panel_info.panels || [];

      panels.forEach((panel) => {
        const panelCode =
          panel.panel_id?.panel_code || panel.lab_order_code || "Uncategorized";
        const panelTitle = panel.panel_id?.panel_title || panelCode;
        const panelId = panel.panel_id?._id || panel.panel_id || panelCode;
        const caseTypeCode = panel.case_type_code || "CLINICAL_CHEMISTRY";
        const labOrderCode = panel.lab_order_code || "";

        if (!grouped[panelCode]) {
          grouped[panelCode] = {
            title: panelTitle,
            panel_id: panelId,
            case_type_code: caseTypeCode,
            lab_order_code: labOrderCode,
            tests: [],
          };
        }

        const enrichedTests = (panel.test_ids || []).map((test) => {
          return {
            _id: test._id,
            test_name: test.test_name,
            test_code: test.test_code,
            lab_order_code: labOrderCode,
            case_type_code: caseTypeCode,
            panel_code: panelCode,
          };
        });

        grouped[panelCode].tests.push(...enrichedTests);
      });

      this.groupedTests = grouped;
      console.log(this.groupedTests, "groupedTests");
      this.showRejectTestPopup = true;
    },
    hasMoreThanOneUniqueCategoryCode() {
      // Guard clause for invalid or missing data
      const testPanelData = this.getCaseInformation?.test_panel_info;
      if (!testPanelData || !Array.isArray(testPanelData.panels)) return false;

      // Extract panel_ids and filter out falsy values
      const panelIds = testPanelData.panels
        .map((panel) => panel.panel_id)
        .filter(Boolean);

      // Get unique panel_ids
      const uniquePanelIds = [...new Set(panelIds)];

      // If more than one unique panel_id, return true
      if (uniquePanelIds.length > 1) {
        return true;
      }

      // Only one panel_id present, check for special cases
      const specialPanelIds = ["ALL_TESTS", "SEND_OUTS"]; // Adjust if specific panel_id strings are known
      if (
        uniquePanelIds.length === 1 &&
        specialPanelIds.includes(uniquePanelIds[0])
      ) {
        // Flatten all test_ids arrays for panels with the special panel_id
        const allTests = testPanelData.panels
          .filter((panel) => specialPanelIds.includes(panel.panel_id))
          .flatMap((panel) => panel.test_ids || []);

        return allTests.length > 1;
      }

      return false;
    },
    checkAllItemsSelected() {
      if (this.allItemsSelected) {
        alert("DON'T Select All Tests");
      }
    },
    getPatietHistory() {
      this.patientHistory = true;
    },
    viewCaseAudit() {
      this.AuditLogsPopup = true;
    },
    goToEditForm() {
      this.$router.push({
        name: "Case-Information-Update",
        params: { case_id: this.$route.params.case_id },
        query: this.$route.query,
      });
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      // For example, adding a class 'scrolled' when the user scrolls more than 100px
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    async viewQrcode() {
      let urlData = this.$router.resolve({
        name: "MultipleQrcodes",
        path: "multiple-qrcodes",
        query: {
          case_ids: this.caseId,
        },
      });
      window.open(urlData.href, "_blank");
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    async viewBarcode() {
      let urlData = this.$router.resolve({
        name: "MultipleBarcodes",
        path: "multiple-barcodes",
        query: {
          case_ids: this.caseId,
        },
      });
      window.open(urlData.href, "_blank");
    },
    async caseDataIntial() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.amendement_details
      ) {
        this.description = `Report Revision Notes: ${this.getCaseInformation.amendement_details.amendment_revision_notes}`;
      }
      this.setPreviewCaseData();
    },
    setPreviewCaseData() {
      try {
        if (!this.getCaseInformation) {
          this.$store.commit("cases/setPreviewCaseData", {}, { root: true });
        } else if (
          this.getPreviewCaseData &&
          this.getCaseInformation.case_types !=
            this.getPreviewCaseData.case_types
        ) {
          this.$store.commit(
            "cases/setPreviewCaseData",
            this.getCaseInformation,
            {
              root: true,
            }
          );
        } else if (!this.getPreviewCaseData && this.getCaseInformation) {
          this.$store.commit(
            "cases/setPreviewCaseData",
            this.getCaseInformation,
            {
              root: true,
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    async unsetCaseMovingStatus(data) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        notes: data.notes,
      };
      if (data.reasons && data.reasons.length > 0) {
        params.reasons = data.reasons;
      }
      await this.updateStatus(params);
    },
    async unsetCaseCompleteStatus(reason) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        reason,
      };

      await this.updateStatus(params);
    },
    async askReasonOnUnsetCompletedStatus(inputData) {
      if (inputData === "COMPLETE") {
        inputData = "Finalized";
      } else if (inputData === "TEST_REPORTS") {
        inputData = "Processing";
      }
      this.takeStatusChangeReasonDialog = true;
      this.takeStatusChangeReasonDialogTitle =
        "Reason for moving from" +
        " " +
        inputData +
        " " +
        "to" +
        " " +
        (this.toStatus === "TEST_REPORTS"
          ? "Processing"
          : this.toStatus
              .split("_")
              .map((e) => this.captilize(e))
              .join(" "));
    },
    async fetchCaseInformation() {
      try {
        this.loading = true;
        this.show = false;
        await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
        if (this.getCaseInformation && this.getCaseInformation.order_id) {
          this.show = true;
          this.orderId = this.getCaseInformation.order;
        }
        await this.caseDataIntial();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async askReasonOnUnsetStatus() {
      this.takeStatusMovingReasonDialog = true;
    },
    async changeStatus(command, id) {
      if (command === "NOT_TO_CALL") {
        return;
      }
      if (command == this.caseInfo.status) {
        return;
      }
      this.takeStatusChangeReasonDialogTitle = command;

      let params = {
        status: command,
        id: this.caseId,
      };

      if (this.caseInfo.status == "COMPLETE" || command == "COMPLETE") {
        this.unsetCompleteStatusChangeCase = this.caseInfo._id;
        this.toStatus = command;
        this.askReasonOnUnsetCompletedStatus(this.caseInfo.status);
      } else if (
        (this.caseInfo.status == "ACTIVE" ||
          this.caseInfo.status == "PENDING" ||
          this.caseInfo.status == "REJECTED") &&
        command != "TEST_REPORTS" &&
        command != "ARCHIVED" &&
        command != "COMPLETE"
      ) {
        this.unsetCompleteStatusChangeCase = this.caseInfo._id;
        this.toStatus = command;
        // this.caseIndex = index;
        this.askReasonOnUnsetStatus();
      } else {
        await this.updateStatus(params);
      }
    },
    async updateStatus(params) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/changeCaseStatus", params);
        this.loading = false;
        if (this.getUpdateCaseStatus && this.getUpdateCaseStatus.success) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateCaseStatus.message,
          });
          window.location.reload();
          this.caseInfo.status = params.status;
          this.refreshViewIfNeeded();
        }
      } catch (error) {
        console.log(error);
      }
    },
    refreshViewIfNeeded() {
      if (
        this.caseInfo.status == "COMPLETE" &&
        this.caseInfo.case_types.length == 1 &&
        this.$route.name == "TestReports"
      ) {
        this.refreshView = true;
        setTimeout(() => {
          this.refreshView = false;
        }, 200);
      }
    },
    async toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#generate-barcode-button {
  background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%);
  color: white;
  border-radius: 7px;
  padding: 6px 20px;
  border: none;
  font-weight: 600;
}

.editCase {
  button {
    display: flex;
    align-items: center;
    cursor: pointer;
    background: none;
    border: none;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    border: 1px solid #f24a55;
    background: #f24a55;
    border-radius: 4px;
    padding: 0 10px;

    img {
      margin-right: 7px;
      margin-bottom: -3px;
      width: 15px;
    }
  }
}

.requisition-d-grid {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  column-gap: 10px;

  .leftBlock {
    background: #ffffff;
    padding: 8px 10px;
    border-radius: 6.40567px;
    border: 1.2px solid #e7e7f7;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

#case-status-button {
  &:hover {
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }
}

.order-status-reason {
  margin-bottom: 5px;

  .bg-white {
    background: #fff;
    padding: 10px;
    border-radius: 6.40567px;
  }

  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    li {
      position: relative;

      &:not(:last-child) {
        p {
          &:after {
            content: ",";
          }

          color: #333;
        }
      }

      .reason-heading {
        text-transform: uppercase;
        color: #333;
        margin-right: 0;
        font-size: 13px;
        color: #f24a55;
      }

      p {
        font-size: 13px;
        font-weight: 500;
        margin: 0;
        line-height: 1.5;
      }

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}
.case-status {
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  justify-content: end;
  li {
    button {
      cursor: default;
    }
  }
}
</style>
